export enum TreatmentInformationComponentPart {
	BridgeInformation = 0,
	TreatmentInformation = 1
}
